import cn from "classnames";

/**
 * Used to extend Downshifts getter utils.
 *
 * @example
 * // Access the getter(s) you would like to extend
 * const {getItemProps: downShiftGetItemProps} = useSelect({...});
 *
 * // Extend the getter to include additional props
 * const getItemProps = extendGetter(downShiftGetItemProps, {"some-props-that": "matter-to-us"});
 *
 * // Use the getter
 * <li {...getItemProps({"add-more-specific": "list-item-props"})}>
 *     List item
 * </li>
 *
 * @param {function} getter
 * @param {object} controlledProps
 * @returns {function} Returns getter
 */
export const extendGetter =
  <T extends object>(getter: (props: T) => any, controlledProps: object) =>
  ({ className: consumerClassName = "", ...consumerProps }: any = {}) => {
    const { className: classList, ...rest } = getter({
      ...controlledProps,
      ...consumerProps,
    });

    return {
      className: cn(classList, consumerClassName),
      ...rest,
    };
  };
